import { forwardRef, type ButtonHTMLAttributes } from 'react';
import { cn } from './cn';

type Variant = 'primary' | 'secondary' | 'ghost' | 'brand' | 'danger';
type Size = 'sm' | 'md' | 'icon';

const variants: Record<Variant, string> = {
  primary: 'bg-ink text-canvas hover:opacity-90 shadow-card',
  secondary: 'bg-panel text-ink border border-line hover:border-line-strong hover:bg-hover shadow-card',
  ghost: 'text-ink-2 hover:text-ink hover:bg-hover',
  brand: 'bg-brand text-white hover:brightness-105 shadow-card',
  danger: 'bg-panel text-offline border border-line hover:bg-offline-soft',
};
const sizes: Record<Size, string> = {
  sm: 'h-7 px-2.5 text-[13px] gap-1.5 rounded-md',
  md: 'h-9 px-3.5 text-sm gap-2 rounded-lg',
  icon: 'h-8 w-8 justify-center rounded-lg',
};

export const buttonClass = (variant: Variant = 'secondary', size: Size = 'md', extra?: string) =>
  cn('inline-flex shrink-0 items-center font-medium whitespace-nowrap transition-[background,border,color,opacity] duration-100 disabled:opacity-50 select-none',
    variants[variant], sizes[size], extra);

export const Button = forwardRef<HTMLButtonElement, ButtonHTMLAttributes<HTMLButtonElement> & { variant?: Variant; size?: Size }>(
  ({ variant, size, className, type = 'button', ...props }, ref) =>
    <button ref={ref} type={type} className={buttonClass(variant, size, className)} {...props} />,
);
Button.displayName = 'Button';
